/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtLiquidityChange = {
  pool: Address;
  position: Address;
  owner: Address;
  tokenAAmount: bigint;
  tokenBAmount: bigint;
  transferFeeIncludedTokenAAmount: bigint;
  transferFeeIncludedTokenBAmount: bigint;
  reserveAAmount: bigint;
  reserveBAmount: bigint;
  liquidityDelta: bigint;
  tokenAAmountThreshold: bigint;
  tokenBAmountThreshold: bigint;
  changeType: number;
};

export type EvtLiquidityChangeArgs = {
  pool: Address;
  position: Address;
  owner: Address;
  tokenAAmount: number | bigint;
  tokenBAmount: number | bigint;
  transferFeeIncludedTokenAAmount: number | bigint;
  transferFeeIncludedTokenBAmount: number | bigint;
  reserveAAmount: number | bigint;
  reserveBAmount: number | bigint;
  liquidityDelta: number | bigint;
  tokenAAmountThreshold: number | bigint;
  tokenBAmountThreshold: number | bigint;
  changeType: number;
};

export function getEvtLiquidityChangeEncoder(): FixedSizeEncoder<EvtLiquidityChangeArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["tokenAAmount", getU64Encoder()],
    ["tokenBAmount", getU64Encoder()],
    ["transferFeeIncludedTokenAAmount", getU64Encoder()],
    ["transferFeeIncludedTokenBAmount", getU64Encoder()],
    ["reserveAAmount", getU64Encoder()],
    ["reserveBAmount", getU64Encoder()],
    ["liquidityDelta", getU128Encoder()],
    ["tokenAAmountThreshold", getU64Encoder()],
    ["tokenBAmountThreshold", getU64Encoder()],
    ["changeType", getU8Encoder()],
  ]);
}

export function getEvtLiquidityChangeDecoder(): FixedSizeDecoder<EvtLiquidityChange> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["tokenAAmount", getU64Decoder()],
    ["tokenBAmount", getU64Decoder()],
    ["transferFeeIncludedTokenAAmount", getU64Decoder()],
    ["transferFeeIncludedTokenBAmount", getU64Decoder()],
    ["reserveAAmount", getU64Decoder()],
    ["reserveBAmount", getU64Decoder()],
    ["liquidityDelta", getU128Decoder()],
    ["tokenAAmountThreshold", getU64Decoder()],
    ["tokenBAmountThreshold", getU64Decoder()],
    ["changeType", getU8Decoder()],
  ]);
}

export function getEvtLiquidityChangeCodec(): FixedSizeCodec<
  EvtLiquidityChangeArgs,
  EvtLiquidityChange
> {
  return combineCodec(
    getEvtLiquidityChangeEncoder(),
    getEvtLiquidityChangeDecoder(),
  );
}
